<app-breadcrumb [title]="'Marcas Inactivas'" [items]="['Vehiculos', 'Marca']" [active_item]="'Marcas Inactivas'"></app-breadcrumb>
<div class="container-fluid">

    <div class="card">
      <div class="card-header bg-primary text-white ">
        <h5 class="text-uppercase">
         <strong> LISTADO Marcas Inactivas</strong>
        </h5>
      </div>

      <div class="card-body custom-datatable noscroll">
          <div class="row mb-12 ">
      <div class="col-sm-12 col-md-3 ms-auto">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Buscar....." [(ngModel)]="searchText"
            (input)="filterData()" />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>
        <div class="custom-datatable table-responsive mt-4">
          <table class="table table-hover table-bordered" id="tblMarcas">
            <thead class="bg-primary">
              <tr>
                <th class="text-center" style="cursor: pointer" (click)="sortData('marca')">
                  <strong>NOMBRE DE MARCA</strong>
                  <i class="fa ms-1" [ngClass]="{
                    'fa-sort-up': sortColumn === 'marca' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'marca' && sortDirection === 'desc',
                    'fa-sort': sortColumn !== 'marca'
                  }"></i>
                </th>
                <th class="text-center"><strong>OPCIONES</strong></th>
              </tr>
            </thead>
          
            <!-- Mostrar registros si hay -->
            <tbody *ngIf="(filteredTableItems?.length ?? 0) > 0; else noRegistros">
              <tr *ngFor="let marca of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                <td class="text-center">{{ marca.marca }}</td>
                <td>
                  <div class="d-flex justify-content-center align-items-center">
                    <ul class="list-inline d-flex gap-3 mb-0">
                      <li class="">
                        <a href="javascript:void(0)"><i class="icon-check-box" (click)="activarMarca(marca.marca)"
                            ngbTooltip="Activar Marca"></i></a>
                      </li>
                     
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          
            <!-- Mostrar mensaje cuando no hay registros -->
            <ng-template #noRegistros>
              <tbody>
                <tr>
                  <td class="text-center" colspan="2">
                    🚫 No hay marcas inactivas registradas.
                  </td>
                </tr>
              </tbody>
            </ng-template>
          </table>

        </div>
      <div class="row align-items-center mt-4 g-2">
    <!-- Selector de registros por página -->
    <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
      <label for="pageSize1" class="me-2 mb-0">Mostrar:</label>
      <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
        <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
      </select>
      <span class="ms-2">registros por página</span>
    </div>

    <!-- Total de registros -->
    <div class="col-12 col-md-4 text-center my-2 my-md-0">
      <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ marcas.length || 0 }}</b></span>
    </div>

    <!-- Paginador -->
    <div class="col-12 col-md-4 text-center text-md-end">
      <pagination-controls 
        (pageChange)="page1 = $event" 
        [maxSize]="5"
        [directionLinks]="true"
        [autoHide]="true"
        previousLabel="Anterior" 
        nextLabel="Siguiente">
      </pagination-controls>
    </div>

    </div>
        <div class="card-body">
          <div class="btn-showcase text-center">
            <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
              (click)="
                exportarExcel(
                  'tblMarcas',
                  'Listado_Marcas'
                )
              ">
              <i class="icofont icofont-file-excel"></i> EXCEL
            </button>

            <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
              (click)="
                exportToPDF(
                  'tblMarcas',
                  'Listado_Marcas',
                  'Listado de Marcas'
                )
              ">
              <i class="icofont icofont-file-pdf"></i> PDF
            </button>

          </div>
        </div>
      </div>
    </div>

</div>

